import { configureStore } from '@reduxjs/toolkit'
import { blogReducer } from './redux/reducers/project'
import { categoryReducer } from './redux/reducers/category'

// export const server = "https://aneftymarketplace-backend.vercel.app"
export const server = "http://localhost:5000"

export const store = configureStore({
  reducer: {
    blog: blogReducer,
    category: categoryReducer
  },
})


